export enum RegistryTypeEnum {
  REDCAP = "REDCAP",
  GENEIAL_S3 = "GENEIAL_S3",
}

export interface IRegistryUpdate {
  title: string;
  abbreviation?: string;
  description: string;
  is_active: boolean;
  is_allow_edit: boolean;
  is_allow_add: boolean;
  registry_type: string;
  registry_brand_url?: string;
  organization_id: string;
  geneial_schema_version_id?: string;
  config_redcap_api_key?: string;
  config_redcap_api_endpoint?: string;
  config_geneial_s3_bucketname?: string;
}

export interface IRegistryCreate extends IRegistryUpdate {}

export interface IRegistryWorkingForm extends Partial<IRegistryUpdate> {}

export interface IRegistry extends IRegistryCreate {
  id: string;
  description: string;
  time_created: string;
  time_updated: string;
}

export const initialRegistryWorkingForm: IRegistryWorkingForm = {
  title: "",
  description: "",
  registry_brand_url: "",
  is_active: true,
  is_allow_edit: true,
  is_allow_add: true,
  registry_type: RegistryTypeEnum.REDCAP,
  organization_id: "",
  geneial_schema_version_id: "",
  config_redcap_api_key: "",
  config_redcap_api_endpoint: "",
  config_geneial_s3_bucketname: "",
};
